const width = window.innerWidth;
const isMobile = width < 768;

export const layout = isMobile
  ? {
      labelCol: { span: 12 },
      wrapperCol: { span: 24 },
    }
  : {};
